<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-panel>
               <span style="font-size: 20px;">
                  {{ !data.id ? $t('wkt.admin.paidabsencecategory.new-window.title') : $t('wkt.admin.paidabsencecategory.edit-window.title' )}}
               </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <v-container>
                          <v-form ref="form">
                              <v-row>
  
                                  <v-col cols="6">                
                                      <v-text-field
                                          v-model="data.name"
                                          :label="$t('wkt.admin.paidabsencecategory.edit-window.name')"
                                          autocomplete="off"
                                          :rules="[validationRules.required]"
                                          maxlength="100"
                                          :disabled="isReadOnly"
                                      />
                                  </v-col>

                                 <v-col cols="4">                
                                      <v-text-field
                                          v-model="data.internalCode"
                                          :label="$t('wkt.admin.paidabsencecategory.edit-window.internal-code')"
                                          autocomplete="off"
                                          maxlength="20"
                                          :disabled="isReadOnly"
                                      />
                                  </v-col>

                                    <v-col cols="2" class="d-flex align-center">
                                       <v-checkbox
                                             v-model="data.isEnabled"
                                             :label="$t('wkt.admin.paidabsencecategory.edit-window.is-enabled')"
                                             :disabled="isReadOnly"
                                       />
                                    </v-col>

                                    <v-col cols="12">                
                                      <v-text-field
                                          v-model="data.description"
                                          :label="$t('wkt.admin.paidabsencecategory.edit-window.description')"
                                          autocomplete="off"
                                          :rules="[validationRules.required]"
                                          maxlength="250"
                                          :disabled="isReadOnly"
                                      />
                                  </v-col>
                                  
                           
                              </v-row>
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()" :disabled="isReadOnly || isNonCorporateLicense">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;" :disabled="isReadOnly || isNonCorporateLicense">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 
  
            <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.paidabsencecategory.edit-window.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.paidabsencecategory.edit-window.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime.js'
import gwt from '../../../api/gwt.js'
import { Constants } from "../../common/Constants.js";

export default {
   name: 'PaidAbsencesCategoryDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         data: {},
         profile: null,
         company: null,
      }
   },
   computed: {
      sessionModulePaidAbsences() {
         return this.profile?.modulePaidAbsencesCategory;
      },
      userHasAnyAccess() {
         const mp = this.sessionModulePaidAbsences;
         return !(mp === Constants.DENY_ALL);
      },
      isReadOnly() {
         return (this.sessionModulePaidAbsences === Constants.ALLOW_READ_ONLY);
      },
      isNonCorporateLicense() {
         return this.company && this.company.licenseType !== Constants.LICENSE_TYPE_CORPORATE;
      },
   },
   methods: {
       // eslint-disable-next-line no-unused-vars
      open(action, payload) {

         if (!this.userHasAnyAccess) {
            this.$emit("show-alert", { text: this.$t("wkt.admin.common.error.try_again_later"), color: "error", timeout: 3000 });
            return;
         }

         this.profile = gwt.getSessionProfile();
         this.company = gwt.getSessionInformation().company;

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         if (!payload) {
            this.data = {
               companyId: gwt.getSessionProfile().companyId,
               isEnabled: true
            };
            this.loading = false; 
            return;
         }

         this.loading = true;
         api.getPaidAbsencesCategoryById(payload, (res) => {
            this.data = res;
            this.loading = false;
         }, (error) => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })


      },
      onSave() {
         if (!this.$refs.form.validate()) {
            return;
         }

         this.loading = true;

         api.storePaidAbsencesCategory(this.data, (res) => {
               this.loading = false;
               if (res.rsOK) {
                  this.showDialog = false;
                  this.$emit('refresh');
               } else {
                  this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
               }
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
         this.loading = true;

            // Valida primero si la categoría está siendo utilizada
         api.getPaidAbsencesCountByCategory(this.data.id, (res) => {
            if (res > 0) {
               this.loading = false;
               this.$emit('show-alert', { 
                  text: this.$t('wkt.admin.paidabsencecategory.edit-window.associated_request_error', [res]), 
                  color: 'error', 
                  timeout: 3000 
               });
               return;
            }

            // Si no está siendo utilizada, procede con la eliminación
            api.deletePaidAbsencesCategory(this.data.id, (res) => {
               this.loading = false;
               this.showDialog = false;

               if (!res.rsOK) {
                  this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
                  return;
               }

               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error && error.message ? error.message : error, color: 'error', timeout: 3000 });
            });
         }, (error) => {
            this.loading = false;
            this.$emit('show-alert',{ text: error && error.message ? error.message : error, color: 'error', timeout: 3000 });
         });
      }
   },
}
</script>